/**
 * BADGE LIST CELL
 * Cellule pour afficher une liste de badges (produits, membres, tags, etc.)
 */

import { Badge } from '@/components/ui/badge';

interface BadgeListCellProps<T> {
  items: T[];
  renderLabel: (item: T) => string;
  getKey: (item: T) => string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  emptyMessage?: string;
  maxDisplay?: number; // Limiter le nombre de badges affichés
  className?: string;
}

export function BadgeListCell<T>({
  items,
  renderLabel,
  getKey,
  variant = 'secondary',
  emptyMessage = '-',
  maxDisplay,
  className,
}: BadgeListCellProps<T>) {
  if (items.length === 0) {
    return <span className="text-sm text-zinc-500">{emptyMessage}</span>;
  }

  const displayItems = maxDisplay ? items.slice(0, maxDisplay) : items;
  const remaining = maxDisplay && items.length > maxDisplay ? items.length - maxDisplay : 0;

  return (
    <div className={`flex flex-wrap gap-1 ${className || ''}`}>
      {displayItems.map((item) => (
        <Badge key={getKey(item)} variant={variant} className="text-xs">
          {renderLabel(item)}
        </Badge>
      ))}
      {remaining > 0 && (
        <Badge variant="outline" className="text-xs">
          +{remaining}
        </Badge>
      )}
    </div>
  );
}
